import React, { useCallback, useEffect, useState } from 'react'
import searchIcon from "../../../../assests/img/search-icon.svg";
import { TCustomSearchBarProps } from 'types/Pages/ProductDelta';
import { debounce } from 'lodash';

/**
 * search input with debounce
 * 
 * @param props 
 * @returns 
 */
const CustomSearchBar = (props: TCustomSearchBarProps) => {
  const [searchTerm, setSearchTerm] = useState<string>(props.value ?? "")
  const debouncedChange = useCallback(debounce(props.handleSearchChange, props.delay ?? 600), []);
  
  const handleSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    e.preventDefault()
    
    setSearchTerm(e.target.value.trimStart())
    debouncedChange(e.target.value.trimStart())
  }

  useEffect(() => {
    setSearchTerm(props.value ?? "")
  }, [props.value])

  return (
    <div className={`tw-flex tw-item-center tw-h-9 tw-rounded-[4px] tw-w-full tw-bg-white tw-border`}>
        <input
          id="inputID"
          type="search"
          className={`tw-w-30 focus:tw-outline-none tw-border-0 tw-text-xs tw-block tw-py-1 tw-px-3 tw-bg-transparent tw-bg-clip-padding tw-text-[#6B778C] focus:tw-text-gray-700 tw-rounded-[4px] tw-flex-grow tw-font-normal tw-shadow-none  autofill:tw-shadow-none`}
          placeholder={props.placeholder ?? "Search category"}
          aria-label="Search"
          aria-describedby="basic-addon1"
          autoComplete={props.autoComplete ?? "on"}
          value = {searchTerm}
          onChange={handleSearchChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          disabled={props.disabled}
        />
        <button
          className={`tw-relative tw-block tw-w-9 tw-aspect-square tw-h-full`}
          type="button"
          onClick={props.handleSearch}
        >
          <img src={searchIcon} alt="Search Category" />
        </button>
      </div>
  )
}

export default CustomSearchBar
